<template>
    <div>
        <slot name="dialogBtn" />
        <el-dialog
            :title="titleTxt"
            width="500px"
            :class="isChineseEvn ? 'prop-dialog' : 'en-prop-dialog'"
            :append-to-body="true"
            :visible.sync="dialogVisible"
        >
            <el-form ref="form" :model="form" :rules="rules" label-width="100px" label-position="left">
                <el-form-item :label="$i18n.t('zhiji.portrait.paramName')" prop="name" class="prop-item">
                    <el-input v-model="form.name" :placeholder="$i18n.t('zhiji.portrait.writeHold')" />
                </el-form-item>
                <el-form-item :label="$i18n.t('zhiji.portrait.paramDesc')" prop="describe" class="prop-item">
                    <el-input v-model="form.describe" :placeholder="$i18n.t('zhiji.portrait.writeHold')" />
                </el-form-item>
                <el-form-item :label="$i18n.t('zhiji.portrait.paramType')" prop="type" class="prop-item">
                    <el-select v-model="form.type" style="width: 100%" :placeholder="$i18n.t('zhiji.portrait.selectHold')">
                        <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item :label="$i18n.t('zhiji.portrait.tableName')" prop="tableName" class="prop-item">
                    <el-input v-model="form.tableName" :placeholder="$i18n.t('zhiji.portrait.writeHold')" />
                </el-form-item>
                <el-form-item :label="$i18n.t('zhiji.portrait.paramSource')" prop="source" class="prop-item">
                    <div class="source-panel">
                        <el-select v-model="form.source" style="width:40%" :placeholder="$i18n.t('zhiji.portrait.selectHold')">
                            <el-option v-for="item in sourceOptions" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select>
                        <el-input
                            v-show="form.source"
                            v-model="form.sourceValue"
                            style="width:60%"
                            :placeholder="$i18n.t('zhiji.portrait.writeHold')"
                        />
                    </div>
                </el-form-item>
                <el-form-item :label="$i18n.t('zhiji.portrait.paramRemark')" prop="remark" class="prop-item">
                    <el-input v-model="form.remark" :placeholder="$i18n.t('zhiji.portrait.writeHold')" />
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button round size="" @click="dialogVisible = false">
                    {{ $i18n.t("zhiji.common.cancel") }}
                </el-button>
                <el-button round size="" type="primary" @click="submit">
                    {{ $i18n.t("zhiji.common.confirm") }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { addParam, updateParam, getParamById } from "../../service";
import { typeOptions } from "../../answerSettingConfig";
import i18n from "@/i18n";
const sourceOptions = () => {
    return [
        {
            label: i18n.t("zhiji.portrait.source.SDK"),
            value: "0"
        },
        {
            label: i18n.t("zhiji.portrait.source.IDIP"),
            value: "1"
        },
        {
            label: i18n.t("zhiji.portrait.source.CUSTOM"),
            value: "2"
        }
    ];
};

export default {
    name: "ParamEdit",
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            dialogVisible: false,
            form: {},
            isChineseEvn: false
        };
    },
    computed: {
        typeOptions() {
            return typeOptions();
        },
        sourceOptions() {
            return sourceOptions();
        },
        titleTxt() {
            return this.data.type === "edit" ? this.$i18n.t("zhiji.portrait.editParam") : this.$i18n.t("zhiji.portrait.addParam");
        },
        rules() {
            return {
                name: [
                    {
                        required: true,
                        trigger: "blur",
                        message: this.$i18n.t("zhiji.portrait.rules.paramName")
                    }
                ],
                describe: [
                    {
                        required: true,
                        trigger: "blur",
                        message: this.$i18n.t("zhiji.portrait.rules.paramDesc")
                    }
                ],
                type: [
                    {
                        required: true,
                        trigger: "blur",
                        message: this.$i18n.t("zhiji.portrait.rules.paramType")
                    }
                ],
                tableName: [
                    {
                        required: true,
                        trigger: "blur",
                        message: this.$i18n.t("zhiji.portrait.rules.form")
                    }
                ],
                source: [
                    {
                        required: true,
                        trigger: "blur",
                        message: this.$i18n.t("zhiji.portrait.rules.paramSource")
                    }
                ]
            };
        }
    },
    watch: {
        dialogVisible(val) {
            // eslint-disable-next-line no-unused-expressions
            val && this.initData();
        },
        titleTxt() {
            this.isChineseEvn = localStorage.getItem("locale") === "cn" ? true : false;
        }
    },
    mounted() {
        this.isChineseEvn = localStorage.getItem("locale") === "cn" ? true : false;
        window.document.addEventListener("click", this.windowClick);
        this.$slots.dialogBtn[0].elm.addEventListener("click", () => {
            this.dialogVisible = true;
        });
    },
    destroyed() {
        window.document.removeEventListener("click", this.windowClick);
        this.$slots.dialogBtn[0].elm.removeEventListener("click", () => {
            this.dialogVisible = false;
        });
    },
    methods: {
        initData() {
            // eslint-disable-next-line no-unused-expressions
            this.$refs.form && this.$refs.form.resetFields();
            this.form = {};
            if (this.data.type === "edit" && this.data.id !== undefined) {
                getParamById({ id: this.data.id }).then(result => {
                    this.form = {
                        ...result,
                        source: result.source.toString()
                    };
                });
            }
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    // eslint-disable-next-line no-unused-expressions
                    this.checkSource() && this.saveAction();
                } else {
                    return false;
                }
            });
        },
        saveAction() {
            const handlers = {
                edit: this.editAction,
                add: this.addAction
            };
            handlers[this.data.type].call(null);
        },
        addAction() {
            addParam(this.form).then(() => {
                this.dialogVisible = false;
                this.$emit("submit", this.form);
            });
        },
        editAction() {
            updateParam(this.form).then(() => {
                this.dialogVisible = false;
                this.$emit("submit", this.form);
            });
        },
        // 当来源为IDIP接口，sourceValue需必填
        checkSource() {
            if (this.form.source === "1" && !this.form.sourceValue) {
                this.$message({
                    message: this.$i18n.t("zhiji.portrait.idipTips"),
                    type: "warning"
                });
                return false;
            }
            return true;
        }
    }
};
</script>

<style lang="scss" scoped>
.el-form {
    .prop-item:last-child {
        margin-bottom: 0;
    }
    .source-panel {
        display: flex;
        /deep/.el-select {
            margin-right: 8px;
        }
    }

    /deep/.el-form-item__label {
        display: flex;
        line-height: 1;
        align-items: center;
    }
}

.en-prop-dialog{
    /deep/.el-form-item__label{
        width: 150px !important;
    }
    /deep/.el-form-item__content{
        margin-left: 150px !important;
    }
}
</style>
